import {Directive, ElementRef, AfterViewInit} from '@angular/core';

@Directive({
    selector: '[appSpectrumColorPicker]'
})
export class SpectrumColorPickerDirective implements AfterViewInit {

    private _element: any;

    constructor(el: ElementRef) {
        this._element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this._element.spectrum({
            preferredFormat: 'hex3',
        });
    }

}
